import { ChevronDown } from "lucide-react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function mergeClasses(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function SidebarItem({
  item,
  isCollapsed,
  onExpand,
  onCollapse,
  role,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const hasSubItems = item.subtitle && item.subtitle.length > 0;
  useEffect(() => {
    if (isCollapsed) {
      setIsOpen(false);
    }
  }, [isCollapsed]);

  const handleClick = () => {
    if (isCollapsed) {
      onExpand();
      if (hasSubItems) {
        setTimeout(() => setIsOpen(true), 100);
      }
    } else if (hasSubItems) {
      setIsOpen(!isOpen);
    }
  };

  const handleLinkClick = (to) => {
    setTimeout(onCollapse, 300);
  };

  const ItemContent = () => (
    <span className="relative group text-[13px] tracking-wide cursor-pointer text-black font-normal">
      {isCollapsed ? (
        <span className="text-[10px] ">{item.title}</span>
      ) : (
        item.title
      )}
      {isCollapsed && (
        <div
          className={mergeClasses(
            "absolute left-full ml-4 px-3 py-2 rounded-lg",
            "bg-white shadow-lg border border-slate-100",
            "text-sm whitespace-nowrap text-slate-700",
            "opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto",
            "transition-all duration-200 z-50 translate-x-2 group-hover:translate-x-0"
          )}
        >
          {item.title}
        </div>
      )}
    </span>
  );

  return (
    <div className="w-full">
      {role && item.roles.includes(role) ? (
        <>
          {item.to ? (
            <Link
              to={item.to}
              onClick={() => handleLinkClick(item.to)}
              className={mergeClasses(
                "flex items-center px-6 py-3",
                "text-slate-600 transition-all duration-200",
                "hover:bg-gray-200 hover:text-gray-600 text-black",
                "active:scale-[0.98]",
                isCollapsed && "justify-center"
              )}
            >
              <ItemContent />
            </Link>
          ) : (
            <button
              onClick={handleClick}
              className={mergeClasses(
                "w-full flex items-center justify-between px-6 py-3",
                "text-slate-600 transition-all duration-200",
                "hover:bg-gray-300 hover:text-gray-600 text-black",
                "active:scale-[0.98]",
                isOpen && "bg-gray-200 text-black",
                isCollapsed && "justify-center"
              )}
            >
              <ItemContent />
              {!isCollapsed && hasSubItems && (
                <ChevronDown
                  className={mergeClasses(
                    "h-3.5 w-3.5 transition-transform duration-300 text-slate-400",
                    isOpen && "transform rotate-180"
                  )}
                />
              )}
            </button>
          )}
        </>
      ) : null}

      {!isCollapsed && hasSubItems && (
        <div
          className={mergeClasses(
            "space-y-0.5",
            "transition-all duration-300",
            isOpen
              ? "max-h-[500px] opacity-100"
              : "max-h-0 opacity-0 overflow-hidden"
          )}
        >
          {item.subtitle?.map(
            (subItem) =>
              true && (
                <Link
                  key={subItem.to}
                  to={subItem.to}
                  onClick={() => handleLinkClick(subItem.to)}
                  className={mergeClasses(
                    "block px-8 py-3",
                    "text-[12px]  tracking-wide font-normal",
                    "hover:bg-gray-200 hover:text-gray-600 text-black",
                    "transition-all duration-200",
                    "active:scale-[0.98]"
                  )}
                >
                  {subItem.subTitle}
                </Link>
              )
          )}
        </div>
      )}
    </div>
  );
}
